<div class="lp-statistics-header">
  <div class="lp-statistics-header__wrapper">
    <button
      tuiIconButton
      class="lp-statistics-header__back-button"
      type="button"
      [appearance]="isDesktop ? 'secondary' : 'icon'"
      [size]="isDesktop ? 'l' : 'm'"
      iconStart="@tui.chevron-left"
      (click)="onClickBackButton()"
    ></button>

    <div class="lp-statistics-header__texts">
      <h1 class="lp-statistics-header__title">{{ title }}</h1>
      <div *ngIf="description && !isMobile" class="lp-statistics-header__description">{{ description }}</div>
    </div>

    <ng-container *ngIf="isLargeScreen || isMobile" [ngTemplateOutlet]="periodTmp"></ng-container>
  </div>

  <ng-container *ngIf="!isLargeScreen && !isMobile" [ngTemplateOutlet]="periodTmp"></ng-container>
</div>

<ng-template #periodTmp>
  <tui-input-date-range
    *ngIf="periodVisible"
    class="period"
    [tuiTextfieldSize]="isDesktop ? 'l' : 'm'"
    [tuiTextfieldCleaner]="true"
    [(ngModel)]="period"
    (ngModelChange)="changPeriod.emit($event)"
  >
    {{ 'components.lpStatisticsHeader.fields.period' | translate }}
  </tui-input-date-range>
</ng-template>
